// Vendors
import { CountriesLocaleEnumeration } from '@gruposantander/opbpay-ui-core-models';

const ALLOWED_LANGUAGES = [CountriesLocaleEnumeration.SPAIN, CountriesLocaleEnumeration.ENGLAND];

const LOCALE_QUERY_PARAM = 'language';

export { ALLOWED_LANGUAGES, LOCALE_QUERY_PARAM };
